import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import ComapanyNameDetails from "../../../../components/common/forms/ComapanyNameDetails";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../components/common/forms/FormPayment";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
// import { pvt_lmt_registration } from "../../../../components/utils/formArray/FormArray";
import {
  public_lmt_registration,
  public_details_of_shareholder,
  public_shareholder,
} from "../PublicCompanyRegistration/PublicCompanyRegArray";

// import Images from "../../../../media/images";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import api from "../../../../api/api";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";
import { useSelector } from "react-redux";

const PublicCompanyRegistration = () => {
  const { register, handleSubmit } = useForm();
  const [shareHolders, setShareHolders] = useState([
    {
      ...public_shareholder,
      id: uuidv4(),
    },
  ]);

  const [paymentRangeList, setPaymentList] = useState([])

  
  const { user } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)
  const [uploadProof, setUploadProof] = useState('')
  const [amount, setAmount] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [dueAmount, setDueAmount] = useState(null)
  const [paidAmount, setPaidAmount] = useState(null)



  // For amount calculation
  useEffect(() => {
    if(amount > 0){
      let arr = paymentRangeList.filter((item) => { 
        return amount >= parseInt(item.range_start) && amount <= parseInt(item.range_end)
      })
      console.log(arr)

      arr.length > 0  && setTotalAmount(arr[0]?.amount)
    }else{
      setTotalAmount(0)
    }
  }, [amount, paymentRangeList])



  // getting current user
  useEffect(()=> {
    api.get("/users/me/")
    .then(response=> {
        setDueAmount(response.due_amount)
    }).catch(error=> {

    }) 
  },[])




  

// for filtering by company_type and show in Modal
  useEffect(() => {
    api.get('/services/company/registration/service-charges/?company_type=public')
    .then(response=> {
        // console.log(response.data)
        setPaymentList(response.data)
    }).catch(error=> {
       console.log(error)
       toast.error("Something went wrong")
    })
  }, [])
  




  const handleClick = (data) => {
    data.share_holders = shareHolders;
    data.company_type = "public";
    data.documents = [];

    if(user?.user_type === "CL"){
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    }else {
        if(userID !== null){
          data.user = userID
        }
    } 



    api
      .post("/services/company/", data)
      .then((response) => {
        // console.log(response);
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof : uploadProof,
          company : response.data.company_id,
          transaction_type: "credit"
       
        };

        api
        .post("/transactions/", transactions)
        .then((response) => {
          toast.success("Data Registered 2 Successfully.");
        })
        .catch((error) => {
          toast.error("Error in Transaction");
        });

      })
      .catch((err) => {
        // console.log(err);
        toast.error("Data Registration Failed.");
      });
  };





  return (
    <div>
      <form className="px-10 lg:!px-14">
        <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
          Public Limited Company Registration Form
        </p>
         
         <div className="mt-3">
          {

           (user?.user_type === "ST" || user?.user_type === "AD")
            && <AdminSearchCustomer 
             setUserId={setUserId}
            /> 
          }
         </div>

        <p className="text-primary-blue text-lg underline">
          1. Company Name Details
        </p>


        <div className="flex flex-col">
          <ComapanyNameDetails register={register} />
        </div>

        <div className="my-5">
          <p className="text-primary-blue mb-5 text-lg underline">
            2. Others Details
          </p>
          <div className="flex gap-3 items-center flex-col md:flex-row">
            <div className="border-primary-blue md:w-[60rem] relative max-w-3xl border-2 border-b font-bold">
              <div>{public_lmt_registration.map((item, i) => {
                const {  ip1, type } = item;
                // console.log(item.validation[i]["required"])
                // console.log(item);
                return (
                  <div
                    key={i}
                    className="border-primary-blue flex flex-col border-b md:flex-row"
                  >

                    <p className="text-primary-red px-5 py-2 sm:!w-[350px] font-Laila">
                      {ip1}
                    </p>

                    {item.ip1 === " कम्पनीको प्रकार" ? (
                      <>
                        <div className="border-primary-blue flex w-full items-center  gap-5 px- py-2 pl-2 border-l-2 md:!py-0">
                          <div className=" px-3 bg-primary-red flex items-center justify-center gap-2 rounded-full  p-1 text-white">
                            <label htmlFor="ekal" className="font-Laila">एकल</label>
                            <input
                              type="radio"
                              id="ekal"
                              value="ekal"
                              {...register("business_type", { required: false })}
                            />
                          </div>

                          <div className=" px-3 bg-primary-red rounded-full border-l p-1 gap-2 font-Laila flex text-white">
                            <label htmlFor="bahul">बहुल</label>
                            <input
                              type="radio"
                              id="bahul"
                              {...register("business_type", { required: false })}
                              value="bahul"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <input
                        name={item.name}
                      
                        {...register(`${item.name}`, 
                        {onChange: (e) => {e.target.name === "authorized_capital" && setAmount(e.target.value)} })}
                        type={type}
                        
                        // {...register(name, validation)}
                        className="border-primary-blue w-full border-t md:border-t-0 py-2 pl-3 outline-none md:border-l-2"
                      />
                    )}
                  </div>
                );
              })}</div>
             <div className="md:absolute font-Laila hidden md:block border  p-1 border-y-1 border-l-1 text-center bottom-0 text-primary-blue border-primary-blue right-0  w-[28%] z-40 bg-red-100 ">
                  शेयर सदस्य तथा पुँजी आधारमा तपाईको जम्मा लाग्ने रकम  <span className="text-red-600">रु.{totalAmount}।–</span> मात्र
                  </div>
              
            </div>
            <div>
              <div className="border-primary-red text-primary-blue text-center  w-fit font-Laila text-sm md:text-base rounded-full border-2 p-2">
                Public Ltd. Company दर्ता शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि
                यहाँ  <span   data-bs-toggle="modal"   data-bs-target="#exampleModalEdit"  className="text-primary-red cursor-pointer">
                   Click
                </span> गर्नुहोस |
                <PrivateCompanyModal paymentRangeList={paymentRangeList} />
              </div>
            </div>
          </div>
        </div>
        <div className="text-primary-blue  text-lg underline">
          3. Details of Share Holders
          <span className="text-primary-blue font-Laila underline">
            (शेयर सदस्य तथा साँक्षीहरुको विवरण | प्रा.लि. कम्पनीमा बढिमा १०१ जना
            सम्म सदस्य रहन सकिन्छ ।)
          </span>
        </div>
 
        {/* Details of shareholders open */}
        <DetailsOfShareHolders
          DetailShareholder={public_details_of_shareholder}
          needed_share={public_shareholder}
          setShareHolders={setShareHolders}
          shareHolders={shareHolders}
        // initialState={initialState}
        />
        {/* Details of shareholders close */}
        <p className="text-primary-blue my-5 text-lg underline">
      4. Main Objectives
        <span className="text-primary-blue font-Laila font-semibold underline">
          (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
        </span>
      </p>
        <MainObjectives register={register} />
        <div className="text-primary-blue text-lg underline my-5">
        5. Working Branch
        <span className="text-primary-blue underline font-Laila text-base font-semibold mx-2">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
          नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>
        <FormBranch register={register} />
        <FormButtom />
        <FormPayment handleSubmit={handleSubmit} handleClick={handleClick}
        totalAmount={totalAmount}
        setUploadProof={setUploadProof}
        dueAmount = {dueAmount}
        setPaidAmount = {setPaidAmount}
        />
      </form>
    </div>
  );
};

export default PublicCompanyRegistration;
